import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { BodyText, LabelText } from '@calendly/ui/components/typography'

export const LockedExternalSection = () => {
  const { values: { redirectConfigurationUrl } } = useFormContext()

  return (
    <>
      <BodyText>
        {I18n.t('publisher.event_types.confirmation_page.type.external')}
      </BodyText>
      <LabelText size="medium">
        {I18n.t('publisher.event_types.confirmation_page.labels.redirect_url')}
      </LabelText>
      <BodyText>
        {redirectConfigurationUrl}
      </BodyText>
    </>
  )
}
